import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AuthService } from 'src/app/core/auth/auth.service';

import { HubServiceBase } from 'src/app/shared/service/hub-service-base';
import { environment } from 'src/environments/environment';
import { Post } from '../model/posts/post';

@Injectable({
    providedIn: 'root',
})
export class PostHubService extends HubServiceBase {
    private movePostToRecycleBin = new Subject<number>();
    public movePost$ = this.movePostToRecycleBin.asObservable();
    private restoredPostSubject = new Subject<Post>();
    public restoredPost$ = this.restoredPostSubject.asObservable();
    private createdPostSubject = new Subject<Post>();
    public createdPost$ = this.createdPostSubject.asObservable();
    private updatedPostSubject = new Subject<Post>();
    public updatedPost$ = this.updatedPostSubject.asObservable();

    constructor(
        private auth: AuthService,
    ) {
        super();
        this.createConnection(environment.hub.post, () => this.auth.accessToken);

        this.on<[number]>('MoveToRecycleBin', (postId: number) => {
            this.movePostToRecycleBin.next(postId);
        });

        this.on<[Post]>('RestorePost', (post: Post) => {
            this.restoredPostSubject.next(post);
        });

        this.on<[Post]>('CreatedPost', (post: Post) => {            
            this.createdPostSubject.next(post);
        });

        this.on<[Post]>('UpdatedPost', (post: Post) => {                       
            this.updatedPostSubject.next(post);
        });
    }
}